import Reflux from "reflux";
import AppConstants from "../constants/AppConstants";

const UIActions = Reflux.createActions([
  "changeStageView",
  "changeColorMode",
  "clearSelectedElements",
  "clearSelected",
  "clearSelectedPage",
  "deactivateLibrarySiteChooser",
  "editTextElement",
  "setUIScale",
  "uiScaleComplete",
  "moveUIScale",
  "incrementZoom",
  "itemOver",
  "itemOut",
  "modalOpen",
  "modalClose",
  "modalDeactivate",
  "openSignupModal",
  "previewOpen",
  "previewClose",
  "toggleGuides",
  "toggleProtorenderer",
  "setButtonState",
  "setFormFieldState",
  "toggleStageOverlay",
  "replaceActiveItemHistory",
  "addActiveItemHistory",
  "removeLastActiveItemHistory",
  "resetElementPropertiesPanel",
  "scrollIntoView",
  "selectBlock",
  "selectBlockState",
  "selectCanvasSet",
  "selectElement",
  "selectActiveLayout",
  "selectLayout",
  "selectModalTab",
  "selectModalChildTab",
  "setMode",
  "setTabs",
  "setChildTabs",
  "selectPage",
  "selectSiteBlock",
  "showLeftPanelView",
  "showRightPanelView",
  "showAppView",
  "showLogin",
  "showProcessing",
  "showUserSites",
  "showLibrarySites",
  "showOffline",
  "showDesignView",
  "showPreviousView",
  "showTheme",
  "showToast",
  "hideToast",
  "showCommandPalette",
  "hideCommandPalette",
  "stageAlteration",
  "setRightClickMenuState",
  "closeRightClickMenu",
  "stageWidthChange",
  "setZoom",
  "toggleActiveFontManagerTab",
  "toggleActiveThemeSettingTab",
  "toggleActiveFonts",
  "toggleActiveTheme",
  "toggleAssetChooser",
  "toggleBlockPropertiesSection",
  "toggleColorMode",
  "toggleDensity",
  "toggleElementPropertiesSection",
  "toggleElementsPropertiesSection",
  "toggleJSONEditor",
  "togglePages",
  "togglePagePropertiesSection",
  "togglePropertiesPanel",
  "toggleRenamePopup",
  "toggleStatePropertiesSection",
  "toggleWorkingOverlay",
  "zoomReset",
  "zoomToWidth",
  "showImageUploadOverlay",
  "hideImageUploadOverlay",
  "resizeGroup"
]);

UIActions.openSignupModal.listen(function (payload) {
  UIActions.modalOpen(AppConstants.MODAL_SIGNUP);
});

export default UIActions;
